import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './VendorAttribution.module.css';
import TextInput from '../ReusableComponents/TextInput/TextInput';

export default function AttributionTextInputs(props) {
  const {
    values: { company_name, first_name, last_name, email, phone },
    invalidEmail = null,
    emptyFields,
    onChange,
    onBlur,
    required,
    disabled,
  } = props;
  const [fields, setValues] = useState({
    company_name,
    first_name,
    last_name,
    email,
    phone,
  });

  const onInputChange = ({ target: { name, value } }) => {
    setValues({ ...fields, [name]: value });
    onChange(name, value);
  };

  return (
    <div>
      <div className={styles.row}>
        <TextInput
          required={required}
          className={styles.companyName}
          error={!!emptyFields.company_name}
          label="Company Name"
          variant="outlined"
          onChange={onInputChange}
          onBlur={({ target: { name, value } }) => onBlur(name, value)}
          name="company_name"
          value={fields.company_name}
          id="vatt-company-name"
          autoComplete="no"
          disabled={disabled}
        />
      </div>
      <div className={styles.row}>
        <TextInput
          required={required}
          className={styles.halfRow}
          error={!!emptyFields.first_name}
          label="First Name"
          variant="outlined"
          onChange={onInputChange}
          onBlur={({ target: { name, value } }) => onBlur(name, value)}
          name="first_name"
          value={fields.first_name}
          id="vatt-first-name"
          autoComplete="no"
          disabled={disabled}
        />
        <TextInput
          required={required}
          error={!!emptyFields.last_name}
          label="Last Name"
          variant="outlined"
          onChange={onInputChange}
          onBlur={({ target: { name, value } }) => onBlur(name, value)}
          name="last_name"
          value={fields.last_name}
          id="vatt-last-name"
          autoComplete="no"
          disabled={disabled}
        />
      </div>
      <div className={styles.row}>
        <TextInput
          required={required}
          className={styles.halfRow}
          error={!!emptyFields.email}
          label="Email"
          variant="outlined"
          onChange={onInputChange}
          onBlur={({ target: { name, value } }) => onBlur(name, value)}
          name="email"
          value={fields.email}
          id="vatt-email"
          autoComplete="no"
          formHelperText={
            invalidEmail && (
              <p className={styles.error}>Please enter a valid email address</p>
            )
          }
          disabled={disabled}
        />

        <TextInput
          required={required}
          error={!!emptyFields.phone}
          label="Phone"
          variant="outlined"
          onChange={onInputChange}
          onBlur={({ target: { name, value } }) => onBlur(name, value)}
          name="phone"
          value={fields.phone}
          id="vatt-phone"
          autoComplete="no"
          disabled={disabled}
        />
      </div>
    </div>
  );
}

AttributionTextInputs.propTypes = {
  values: PropTypes.shape({
    company_name: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  invalidEmail: PropTypes.bool,
  emptyFields: PropTypes.shape({}).isRequired,
  required: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
};
